"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var React = _interopDefault(require("react")),
  reactRouterDom = require("react-router-dom"),
  getPage = function getPage() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
      t = arguments[1],
      o = e.map(function (e) {
        return e.pathname;
      }).indexOf(t);
    return o > -1 ? e[o] : void 0;
  },
  getIndexPage = function getIndexPage() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
      t = arguments[1];
    return e.map(function (e) {
      return e.pathname;
    }).indexOf(t);
  },
  saveUrl = function saveUrl(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
      n = Array.isArray(e) ? e : [],
      r = getIndexPage(n, t);
    return r > -1 ? (n[r].scroll = o, n) : (n.push({
      pathname: t,
      scroll: o
    }), n);
  },
  getScrollPage = function getScrollPage() {
    var e = 0;
    return document.documentElement && null !== document.documentElement && (e = document.documentElement.scrollTop), window.pageYOffset || e;
  },
  scrollTo = function scrollTo() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
    return window.requestAnimationFrame(function () {
      window.scrollTo(0, e);
    });
  },
  isBrowser = function isBrowser() {
    return "undefined" != typeof window;
  },
  ScrollMemory = function (e) {
    function t(o) {
      _classCallCheck(this, t);
      var n = _possibleConstructorReturn(this, e.call(this, o));
      return n.detectPop = n.detectPop.bind(n), n.url = [], n.requestID = 0, n;
    }
    return _inherits(t, e), t.prototype.componentDidMount = function () {
      isBrowser() && window.addEventListener("popstate", this.detectPop);
    }, t.prototype.componentWillReceiveProps = function (e) {
      if (isBrowser()) {
        var t = this.props.location,
          o = e.location !== t,
          n = getScrollPage();
        o && (this.requestID = scrollTo(0), this.url = saveUrl(this.url, t.pathname, n));
      }
    }, t.prototype.componentWillUnmount = function () {
      isBrowser() && window.removeEventListener("popstate", this.detectPop);
    }, t.prototype.detectPop = function () {
      if (isBrowser()) {
        var e = window.location.pathname,
          t = getPage(this.url, e);
        this.requestID > 0 && (window.cancelAnimationFrame(this.requestID), this.requestID = 0), t && scrollTo(t.scroll);
      }
    }, t.prototype.render = function () {
      return null;
    }, t;
  }(React.Component),
  ScrollMemory$1 = reactRouterDom.withRouter(ScrollMemory);
module.exports = ScrollMemory$1;